import { IStoreState } from 'modules/types';

export const getAllCTACards = (state: IStoreState) => state.componentDetail.ctaCards;
